<template>
  <div class="full-width answer pa-2">
    <div
      layout="row"
      layout-align="start start"
    >
      <avatar
        v-if="isMEN && $store.state.men_logo"
        size="25"
        :image="$store.state.men_logo"
        :fullname="fullname"
      ></avatar>
      <avatar
        v-else
        @click.native="(!isCurrent && !isMEN && !isDeleted) ? $router.push({name: 'representatives-show', params: {id: creatorId}}) : () => {}"
        :class="{'clickable': (!isCurrent && !isMEN && !isDeleted)}"
        size="25"
        :image="getImageData(creatorId)"
        :fullname="fullname"
      ></avatar>
      <div
        layout="column"
        layout-align="center start"
        class="ml-2"
      >
        <div
          layout="row"
          layout-wrap
          class="pl-1"
        >
          {{$t('_.by')}}&nbsp;
          <strong>{{byWhoMain}}</strong>
          &nbsp;
          <span class="hidden-sm-and-down">{{byWhoSec}}</span>
        </div>
        <div
          layout="row"
          layout-align="start center"
        >
          <v-chip
            label
            :color="levelColor(level)"
            class="text-lowercase mr-2"
            text-color="white"
            style="width: fit-content"
            small
          >{{levelLabel(level)}}</v-chip>
          <span class="hidden-sm-and-down">{{$t('_.on')}} {{formatDateHumanI18n(createdAt)}} {{$t('_.at')}} {{formatHour(createdAt)}}</span>
        </div>
      </div>
      <span flex></span>
      <v-menu
        v-model="menu"
        ref="menu"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        origin="top right"
        offset-x
        offset-y
        bottom
        left
        full-width
      >
        <a
          v-if="!$vuetify.breakpoint.smAndDown"
          href="#"
          @click.prevent
          slot="activator"
          class="mr-1"
          :disabled="!menuList || !menuList.length"
        >{{$t('messages.manage')}}</a>
        <v-btn
          v-else
          slot="activator"
          flat
          depressed
          light
          color="transparent"
          :disabled="!menuList || !menuList.length"
          small
          class="ma-0 pa-0 mr-1"
          style="min-width: fit-content;"
        >
          <v-icon color="black">mdi-dots-vertical</v-icon>
        </v-btn>
        <v-list v-if="menuList && menuList.length">
          <v-list-tile
            v-for="(item, index) in menuList"
            :key="index"
            @click="item.action"
            :disabled="item.disabled"
          >
            <v-list-tile-action style="min-width: auto">
              <v-icon
                :color="item.color ? item.color : 'black'"
                class="mr-2"
              >mdi-{{item.icon}}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title
                v-text="item.title"
                :class="[item.text ? item.text + '--text' : '']"
              ></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
    <div class="pa2-pc pa1-mobile mt-2">
      <div
        v-if="message.medias && message.medias.length"
        class="grid"
        :id="'grid'+message.id"
        @keydown="onKeyDown"
        tabindex="0"
      >
        <div class="grid-sizer"></div>
        <template v-for="(m,i) in message.medias.slice(0,3)">
          <div
            @click="activeImage(m, i)"
            :key="'media_'+m.id"
            v-if="getImageData(m.id + '-300px') || getImageData(m.id)"
            class="grid-item clickable"
            style="position: relative"
          >
            <video
              v-if="isVideo(getImageData(m.id + '-300px')) || isVideo(getImageData(m.id))"
              :src="getImageData(m.id + '-300px') || getImageData(m.id)"
              allowfullscreen="allow"
              controls
              @click.stop="() => {}"
            ></video>
            <img
              v-else
              :src="getImageData(m.id + '-300px') || getImageData(m.id)"
              style="position: relative"
            >
            <div
              v-if="i == 2 && message.medias.length > 3"
              class="text-image"
            >
              +{{message.medias.length - 3}}
            </div>
          </div>
        </template>
        <template v-for="(m,i) in message.medias">
          <div
            v-if="currentImageId == m.id"
            :class="{'gallery-entry': true, 'active': m.id === currentImageId}"
            @click="activeImage(m, i)"
            layout="row"
            layout-align="center center"
            :key="'mediaactive_'+m.id"
          >
            <span
              class="icontainer"
              layout="row"
              layout-align="center center"
            >
              <v-btn
                icon
                @click.stop="previousPicture"
                v-if="m.id === currentImageId"
                style="position: absolute; z-index: 108; left: 0px;"
              >
                <v-icon color="white">mdi-arrow-left</v-icon>
              </v-btn>
              <span flex></span>
              <video
                v-if="isVideo(getImageData(m.id + '-1280px')) || isVideo(getImageData(m.id))"
                :src="getImageData(m.id + '-1280px') || getImageData(m.id)"
                allowfullscreen="allow"
                controls
                @click.stop="() => {}"
              ></video>
              <img
                v-else
                :src="getImageData(m.id + '-1280px') || getImageData(m.id)"
              >
              <span flex></span>
              <v-btn
                icon
                @click.stop="nextPicture"
                v-if="m.id === currentImageId"
                style="position: absolute; z-index: 108; right: 0px;"
              >
                <v-icon color="white">mdi-arrow-right</v-icon>
              </v-btn>
            </span>
          </div>
        </template>
      </div>
      <div
        layout="row"
        layout-align="start start"
        class="full-width"
        layout-wrap
      >
        <div
          layout="column"
          flex
        >
          <div
            v-linkified
            style="white-space: pre-line; word-wrap: break-word;font-family: inherit;"
          >{{message.body}}</div>
        </div>
      </div>
      <div
        v-for="d in message.documents"
        :key="'doc_'+d.id"
        layout="row"
        layout-align="start center"
        class="full-width mt-3 mt2-mobile primary--text"
      >
        <v-icon
          color="primary"
          class="ml-0 mr-1 clickable"
          @click="downloadDoc(d)"
        >mdi-paperclip</v-icon>
        <span
          class="break-word clickable"
          @click="downloadDoc(d)"
        >{{d.document ? d.document.name : ''}}</span>
      </div>
    </div>
    <v-dialog
      v-model="deleteDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('messages.delete_dialog')}}</v-card-title>
        <v-card-text>
          {{$t('messages.delete_info')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="deleteDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="deleteDialog = false; deleteMessage()"
          >
            {{$t('_.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title class="title">{{$t('messages.remove_dialog')}}</v-card-title>
        <v-card-text>
          {{$t('messages.remove_info')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="removeDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="removeDialog = false; removeMessage()"
          >
            {{$t('messages.remove')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="reportDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title class="title">{{$t('messages.report_dialog')}}</v-card-title>
        <v-card-text>
          {{$t('messages.report_info')}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            flat="flat"
            @click="reportDialog = false"
          >
            {{$t('_.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            depressed
            @click="reportDialog = false; reportMessage()"
          >
            {{$t('messages.report_valid')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import I18nMixin from '@/mixins/i18n'
import Consts from '@/consts'
import ImageMixin from '@/mixins/image'
import Avatar from '@/components/shared/Avatar.vue'
import Auth from '@/plugins/auth'
import Messages from '@/api/messages'
import axios from 'axios'
import EventBus from '@/plugins/eventbus'
import Masonry from 'masonry-layout'
import imagesLoaded from 'imagesloaded'
import FormDataMixin from "@/mixins/formdata"
export default {
  mixins: [I18nMixin, ImageMixin, FormDataMixin],
  components: { Avatar },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  data () {
    return {
      imgs: {},
      imgsLoad: {},
      menu: false,
      deleteDialog: false,
      removeDialog: false,
      reportDialog: false,
      currentImageId: null,
      currentImageIndex: null,
    }
  },
  mounted () {
    if (this.message.creator && this.message.creator.avatar_id) {
      this.getImage('/assets/users/' + this.message.creator_id, this.message.creator_id)
    }
    //Charge les preview des médias ou directement les médias
    var grid = document.querySelector('#grid' + this.message.id)

    if (grid) {
      var msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
        horizontalOrder: true,
      })

      let loadedP = []
      for (let i = 0; i < this.message.medias.length; i++) {
        let l = this.getImage('/assets/messageMedias300px/' + this.message.medias[i].id, this.message.medias[i].id + '-300px')
        loadedP.push(l)

        l.catch(() => {
          let l_fallback = this.getImage('/assets/messageMedias/' + this.message.medias[i].id, this.message.medias[i].id)
          loadedP.push(l_fallback)
        })
      }

      Promise.all(loadedP).then(() => {
        this.$nextTick(() => {
          imagesLoaded(grid, () => {
            msnry.reloadItems()
            msnry.layout()
          })
        })
      })
    }
  },
  computed: {
    //Retourne soit le nom complet soit null si l'utilisateur a été anonymisé
    fullname () {
      if (this.message.created_by && this.message.creator && this.message.creator.firstname && this.message.creator.lastname) {
        return this.message.creator.firstname + ' ' + this.message.creator.lastname
      }
      return null
    },
    byWhoMain () {
      let r = ""
      if (this.isCurrent) {
        r += this.$t("_.yourself")
      } else if (this.isMEN) {
        r += this.$t("_.the") + " MEN"
      } else if (this.isDeleted && !this.isAbusiveManage) {
        r += this.$t("users.inactive")
      } else {
        r += this.fullname
      }
      return r
    },
    byWhoSec () {
      let r = ""
      if (!this.isMEN && this.school && this.school.name) {
        r += "("
        r += this.school.name
        r += ")"
      } else if (this.isMEN && this.isAdmin && !this.isCurrent) {
        r += "("
        r += this.fullname
        r += ")"
      }
      return r
    },
    userId () {
      return Auth.user.id
    },
    creatorId () {
      return this.message.creator_id
    },
    createdAt () {
      return this.message.created_at
    },
    school () {
      return this.message.school
    },
    level () {
      return this.message.level
    },
    isDeleted () {
      if (this.message.creator.is_deleted) {
        return true
      }
      return false
    },
    isMEN () {
      if (this.message.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
    ministry () {
      return Consts.MINISTRY
    },
    isCurrent () {
      if (Auth.user.id == this.message.creator_id) {
        return true
      }
      return false
    },
    isReportaable () {
      if (!this.message.circles || !this.message.circles.length) {
        return true
      }
      let priv = false
      for (let i = 0; i < this.message.circles.length; i++) {
        if (this.message.circles[i].is_private) {
          priv = true
          break
        }
      }

      return !priv
    },
    menuList () {
      let list = []
      if (this.isCurrent) {
        list.push({
          title: this.$t('messages.edit'),
          icon: 'pencil',
          action: () => this.$emit(`edit`)
        })
        list.push({
          title: this.$t('messages.delete'),
          icon: 'delete',
          color: 'red',
          text: 'red',
          action: () => this.openDeleteDialog()
        })
      }
      else {
        if (this.isAdmin) {
          if (this.message.is_enabled) {
            list.push({
              title: this.$t('messages.remove_mess'),
              icon: 'lock',
              color: 'red',
              action: () => this.openRemoveDialog()
            })
          }
        } else {
          if (this.isReportaable) {
            list.push({
              title: this.$t('messages.report'),
              icon: 'alert-octagon',
              color: 'red',
              action: () => this.openReportDialog()
            })
          }
        }
      }
      return list
    },
    isAdmin () {
      if (Auth.user.is_admin || Auth.user.level == Consts.MINISTRY) {
        return true
      }
      return false
    },
  },
  methods: {
    openReportDialog () {
      this.reportDialog = true
    },
    openDeleteDialog () {
      this.deleteDialog = true
    },
    openRemoveDialog () {
      this.removeDialog = true
    },
    levelLabel (l) {
      switch (l) {
        case Consts.MINISTRY:
          return this.$t('users.lv_min')
        case Consts.NATIONAL:
          return this.$t('users.lv_nat')
        case Consts.SECTORAL:
          return this.$t('users.lv_sec')
        case Consts.LOCAL:
          return this.$t('users.lv_loc')
      }
    },
    levelColor (l) {
      switch (l) {
        case Consts.MINISTRY:
          return 'primary'
        case Consts.NATIONAL:
          return 'pink'
        case Consts.SECTORAL:
          return 'secondary'
        case Consts.LOCAL:
          return 'brown'
      }
    },
    sectorLabel (s) {
      switch (s) {
        case Consts.PRIMARY:
          return this.$t('schools.sector_prim')
        case Consts.SECONDARY:
          return this.$t('schools.sector_sec')
        case Consts.COMPETENCECENTRE:
          return this.$t('schools.sector_comp')
      }
    },
    reportMessage () {
      Messages.report(this.message.id).then(() => {
        this.$snotify.success(this.$t('messages.reported'))
        this.$emit(`reported`)
      })
    },
    deleteMessage () {
      Messages.delete(this.message.id).then(() => {
        this.$snotify.success(this.$t('messages.deleted'))
        this.$emit(`deleted`)
      })
    },
    removeMessage () {
      Messages.disable(this.message.id).then(() => {
        this.$snotify.success(this.$t('messages.removed'))
        this.$emit(`removed`)
        EventBus.$emit('abusive-updated')
      })
    },
    isVideo (data) {
      if (data && data.indexOf('data:video/') == 0) {
        return true
      }
      return false
    },
    downloadDoc (doc) {
      const doc_id = doc.id
      axios.get(`/assets/messageDocs/${doc_id}`, { responseType: 'blob', }).then(res => {
        this.downloadFile(res.data, doc.document.name)
      })
    },
    onKeyDown (e) {
      if (e.keyCode === 27 /*esc*/) {
        this.activeImage(null, null)
      } else if (this.currentImageIndex != null && e.keyCode === 37 /*left arrow*/) {
        this.previousPicture()
      } else if (this.currentImageIndex != null && e.keyCode === 39 /*right arrow*/) {
        this.nextPicture()
      }
    },

    previousPicture () {
      if (this.currentImageIndex === 0) {
        this.activeImage(this.message.medias[this.message.medias.length - 1], this.message.medias.length - 1)
      } else {
        this.activeImage(this.message.medias[this.currentImageIndex - 1], this.currentImageIndex - 1)
      }
    },

    nextPicture () {
      if (this.currentImageIndex >= this.message.medias.length - 1) {
        this.activeImage(this.message.medias[0], 0)
      } else {
        this.activeImage(this.message.medias[this.currentImageIndex + 1], this.currentImageIndex + 1)
      }
    },

    activeImage (p, i) {
      this.currentImageIndex = i
      if (this.currentImageId === null || p !== null && p.id !== this.currentImageId) {
        this.getImage('/assets/messageMedias1280px/' + p.id, p.id + '-1280px').then(() => {

        }, () => {
          this.getImage('/assets/messageMedias/' + p.id, p.id)
        })

        this.currentImageId = p.id
      } else {
        this.currentImageId = null
      }
    },
  },
}
</script>
<style scoped>
.answer-body {
  background-color: rgb(250, 250, 250);
  border-radius: 5px 5px;
}
.answer {
  background-color: rgb(247, 247, 247);
}
.message-btn {
  height: 14px;
  width: 14px;
  border: 1px;
  border-radius: 50% 50%;
}

/* clear fix */
.grid:after {
  content: "";
  display: block;
  clear: both;
}

/* ---- .grid-item ---- */

.grid-sizer,
.grid-item {
  width: 33.333%;
}

.grid-item {
  float: left;
}

.grid-item img,
.grid-item video {
  display: block;
  max-width: 100%;
  width: 100%;
}

.grid-item {
  position: relative;
}

.grid {
  width: 100%;
  margin: 0 auto;
  outline: none;
  max-width: 500px;
}

.text-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: flex;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-size: 50px;
}

@media screen and (max-width: 960px) {
  .message-media {
    max-width: 100%;
    max-height: 200px;
  }
  .participate-col {
    width: 100%;
  }
}
@media screen and (min-width: 960px) {
  .message-media {
    max-width: 300px;
    max-height: 300px;
  }
  .participate-col {
    min-width: 250px;
  }
}

.gallery-entry {
  position: relative;
  cursor: pointer;
  margin: 12px;
  /*transition: background-color .3s ease-in-out;*/
}

.gallery-entry.active {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  margin: 0;
  z-index: 5;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.gallery-entry > .icontainer {
  text-align: center;
}

.gallery-entry.active > .icontainer {
  width: 100%;
  height: 100%;
  /*padding-top: 128px;*/
}

.gallery-entry img {
  max-width: 165px;
  max-height: 165px;
}

.gallery-entry.active img,
.gallery-entry.active video {
  max-width: 100%;
  max-height: 100%;
  z-index: 8;
  margin: auto;
}

.gallery-entry > div {
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  padding: 8px;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}

.gallery-entry > div > div {
  pointer-events: none;
}

.gallery-entry:hover > div {
  opacity: 1;
}

.gallery-entry.active > div {
  opacity: 1;
  top: 0;
  bottom: unset;
}
</style>
<style>
video.message-media:-webkit-full-screen,
audio.message-media:-webkit-full-screen {
  max-width: 100%;
  max-height: 100%;
}
.linkified {
  word-break: break-all;
}
</style>